import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

class PasswordInput extends Component {
    render() {
        return (
            <div className="question-input">
                <input
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    type="password"
                />
            </div>
        );
    }
}

PasswordInput.propTypes = {
    fieldName:  PropTypes.string.isRequired,
    storageKey: PropTypes.string,
    source:     PropTypes.string,
    isValid:    PropTypes.func,
};

export default PasswordInput;


// WEBPACK FOOTER //
// ./src/components/Fields/PasswordInput.js